import { Table } from "element-ui";
import Auth from "@/lib/common/auth";
import Vue from "vue";

export interface Column {
  id: string;
  realWidth: number;
  minWidth?: number;
  width?: number;
}

const MyTable = Vue.extend({
  name: "ElTable",
  extends: Table,
  props: {
    border: {
      // 要拖动手动传true
      type: Boolean,
      default: false
    },
    useCache: {
      // 是否使用缓存列宽
      type: Boolean,
      default: false
    },
    constId: {
      // 每个表格的固定id，不传则用当前路由当作该表格唯一标识
      type: String,
      default: ""
    },
    resize: {
      type: Boolean, // 是否可拖拽
      default: true
    }
  },
  data() {
    return {
      isExcute: false,
      uid: "",
      defaultColumns: [] as Column[]
    };
  },
  mounted() {
    if (this.border) {
      this.getHandelMounse((this as any).data);
    }
  },
  watch: {
    data: {
      handler(nval: object[]) {
        if (this.border) {
          this.getHandelMounse(nval);
        }
      },
      deep: true
    }
  },
  methods: {
    // 初始化列的设置
    initColumnsSetting() {
      // 首次进入存储默认值
      this.uid = `${Auth.companyId}:${Auth.userId}:${
        this.constId ? this.constId : this.$route.path
      }:`;
      const defaultKey = this.uid + "default";
      const defaultColumns = localStorage.getItem(defaultKey);
      if (!defaultColumns) {
        const columns = (this as any).columns.map((column: any) => ({
          minWidth: column.minWidth,
          width: column.width,
          realWidth: column.realWidth,
          label: column.label
        }));
        localStorage.setItem(defaultKey, JSON.stringify(columns));
      }
      try {
        this.defaultColumns = JSON.parse(
          localStorage.getItem(defaultKey) as string
        );
      } catch (error) {
        console.log(error);
      }
      // 若修改过设置为修改过的列宽
      const adjustColumns = this.getAdjustColumns();
      if (adjustColumns) {
        this.setColumns(adjustColumns);
      }
    },
    // 设置列宽
    setColumns(columns: Column[]) {
      (this as any).columns.forEach((column: any, index: number) => {
        if (!column.fixed) {
          const obj = columns.find(
            (el: any) => el.label === column.label && el.label
          ) as any;
          if (obj) {
            column.width = obj.width;
            column.minWidth = obj.minWidth;
            column.realWidth = obj.realWidth;
          } else {
            column.width = columns[index].width;
            column.minWidth = columns[index].minWidth;
            column.realWidth = columns[index].realWidth;
          }
        }
      });
      (this as any).doLayout();
    },
    // 恢复默认列宽
    resetDefaultColumns() {
      (this as any).columns.forEach((column: any, index: number) => {
        if (!column.fixed) {
          const obj = this.defaultColumns.find(
            (el: any) => el.label === column.label && el.label
          ) as any;
          if (obj) {
            column.width = obj.width;
            column.minWidth = obj.minWidth;
            column.realWidth = obj.realWidth;
          } else {
            column.width = this.defaultColumns[index].width;
            column.minWidth = this.defaultColumns[index].minWidth;
            column.realWidth = this.defaultColumns[index].realWidth;
          }
        }
      });
      (this as any).doLayout();
      // 清除用户保存的列宽
      const adjustKey = this.uid + "adjust";
      localStorage.removeItem(adjustKey);
    },
    // 获取修改的列宽
    getAdjustColumns() {
      const adjustKey = this.uid + "adjust";
      const adjustColumns = localStorage.getItem(adjustKey);
      if (adjustColumns) {
        return JSON.parse(adjustColumns);
      } else {
        return null;
      }
    },
    // 保存修改的列宽
    saveAdjustColumns() {
      const adjustKey = this.uid + "adjust";
      const columns = (this as any).columns.map((column: any) => ({
        minWidth: column.minWidth,
        width: column.width,
        realWidth: column.realWidth,
        label: column.label
      }));
      localStorage.setItem(adjustKey, JSON.stringify(columns));
    },
    // 覆盖
    getHandelMounse(data: object[]) {
      if (!this.isExcute && JSON.parse(JSON.stringify(data))?.length) {
        this.isExcute = true;
        this.$nextTick(() => {
          // 覆盖原来的操作
          if (this.$refs.rightFixedTableHeader) {
            // 做个保护
            (this.$refs
              .rightFixedTableHeader as any).handleMouseDown = this.handleMouseDown;
          }
          (this as any).$refs.tableHeader &&
            ((this as any).$refs.tableHeader.handleMouseDown = this.handleMouseDown);
          (this as any).columns.forEach((column: any) => {
            if (!this.resize) {
              column.resizable = false;
            }
            if (column.fixed) {
              column.resizable = false;
            }
          });
          if (this.useCache) {
            this.initColumnsSetting();
          }
        });
      }
    },
    // 有注释的行或块为自己改动的地方
    handleMouseDown(event: MouseEvent, column: any) {
      if (!this.resize) return; // 不需要拖动
      if (event.button == 2) return; // 右键不要，考虑有可能配置为左手使用鼠标，也可取消contextmenu
      if (column.fixed) return; // 固定列不要拖动

      const _this = (this as any).$refs.tableHeader; // 取tableheader
      if (_this.$isServer) return;
      if (column.children && column.children.length > 0) return;
      if (_this.draggingColumn && _this.border) {
        const table = _this.$parent;
        const tableEl = table.$el;

        const tableBodyWrapper = tableEl.querySelector(
          ".el-table__body-wrapper"
        ); // 滚动体容器

        const tableLeft = tableEl.getBoundingClientRect().left;
        const columnEl = _this.$el.querySelector(`th.${column.id}`);
        const columnRect = columnEl.getBoundingClientRect();
        // const minLeft = columnRect.left - tableLeft + 30; // 不用原有的
        const minLeft =
          columnRect.left -
          (column.minWidth
            ? tableLeft - column.minWidth
            : tableLeft +
              32 +
              this.getTextWidth(columnEl.children[0].innerHTML)); // 加上表头文本（有的会带icon）的宽度和两边边距
        const removeClass = (el: HTMLElement, cls: string) => {
          if (!el || !cls) return;
          const classes = cls.split(" ");
          let curClass = " " + el.className + " ";

          for (let i = 0, j = classes.length; i < j; i++) {
            const clsName = classes[i];
            if (!clsName) continue;

            if (el.classList) {
              el.classList.remove(clsName);
            } else if (this.hasClass(el, clsName)) {
              curClass = curClass.replace(" " + clsName + " ", " ");
            }
          }
          if (!el.classList) {
            el.className = (curClass || "").replace(
              /^[\s\uFEFF]+|[\s\uFEFF]+$/g,
              ""
            );
          }
        };
        const addClass = (el: HTMLElement, cls: string) => {
          if (!el) return;
          let curClass = el.className;
          const classes = (cls || "").split(" ");

          for (let i = 0, j = classes.length; i < j; i++) {
            const clsName = classes[i];
            if (!clsName) continue;

            if (el.classList) {
              el.classList.add(clsName);
            } else if (!this.hasClass(el, clsName)) {
              curClass += " " + clsName;
            }
          }
          if (!el.classList) {
            el.className = curClass;
          }
        };
        addClass(columnEl, "noclick");
        addClass(tableEl, "is-my-click"); // 给表格加上类名用于显示所有的拖拽表头

        let raf: any; // 存储raf
        let endMoveFlag = false; // 记录滚动到最后列拖动的标志

        const currentColumnIndex = (this as any).columns.findIndex(
          (item: any) => item.label === column.label
        ); // 当前列

        // 前面所有自适应列
        const beforeFlexColumns = (this as any).columns
          .slice(0, currentColumnIndex)
          .filter((column: any) => typeof column.width !== "number");

        if (
          (this as any).columns[currentColumnIndex + 1].fixed &&
          !beforeFlexColumns.length
        ) {
          // 如果固定列的前一列且已没有了flex列不让拖动，防止表格断裂
          removeClass(tableEl, "is-my-click");
          return;
        }

        // 后面所有自适应列
        const afterFlexColumns = (this as any).columns
          .slice(currentColumnIndex + 1, (this as any).columns.length)
          .filter((column: any) => typeof column.width !== "number");

        const noFlex = !beforeFlexColumns.length && !afterFlexColumns.length; // 若没有flex列时需手动增加宽度防止表格断裂

        // 前面自适应列总最小宽度
        const beforeTotal = beforeFlexColumns.reduce(
          (prev: any, column: any) => prev + column.minWidth,
          0
        );
        // 后面自适应列总最小宽度
        const afterTotal = afterFlexColumns.reduce(
          (prev: any, column: any) => prev + column.minWidth,
          0
        );
        const ratio = beforeTotal / afterTotal; // 当前列的（前：后）用于后面计算伸缩量调整线的位置
        const initNoScroll = this.hasClass(
          tableBodyWrapper,
          "is-scrolling-none"
        ); // 若初始没有滚动那么在该次拖动中始终按照无滚动的情况计算防止出现跳动
        const initRightScroll = this.hasClass(
          tableBodyWrapper,
          "is-scrolling-right"
        ); // 初始滚动到最右面，用于从滚动最右面到表格没有滚动的情况
        let s = 0; // 记录minwidth自动分配导致拖动列的前面列产生的偏移量
        let freeze = false; // 记录当前列是否达到了最小宽度

        _this.dragging = true;
        _this.$parent.resizeProxyVisible = true;
        _this.dragState = {
          startMouseLeft: event.clientX,
          startLeft: columnRect.right - tableLeft,
          startColumnLeft: columnRect.left - tableLeft,
          tableLeft
        };

        document.onselectstart = function() {
          return false;
        };
        document.ondragstart = function() {
          return false;
        };

        const resizeProxy = table.$refs.resizeProxy;
        resizeProxy.style.left = _this.dragState.startLeft + "px";

        const handleMouseMove = (event: MouseEvent) => {
          // 原有只调整了proxyline，加上表格整体调整，需要节流
          if (raf) return; // 节流

          if (noFlex) {
            // 没有flex时给最后一个非固定列设置flex
            const index = (this as any).columns.findLastIndex(
              (item: any) => item.fixed
            );
            if (index === -1) {
              (this as any).columns[
                (this as any).columns.length - 1
              ].width = null;
            } else {
              (this as any).columns[index - 1].width = null;
            }
          }

          // 无滚动有滚动切换时eltable重设类名，手动再加一次
          if (!this.hasClass(tableEl, "is-my-click")) {
            addClass(tableEl, "is-my-click");
          }

          const deltaLeft = event.clientX - _this.dragState.startMouseLeft;

          // 滚动到最右边，向左拖拽时不要动proxy线，列宽的计算方式变成原宽+移动距离
          // 两种情况都需要该方式处理：初始滚动在最右边；滚动过程中缩小了列宽导致滚动在最右边
          // 该情况下若不处理，表格整体会向后缩，线会向前导致线与该列错位
          if (
            (initRightScroll && deltaLeft < 0) ||
            (this.hasClass(tableBodyWrapper, "is-scrolling-right") &&
              deltaLeft < 0)
          ) {
            // 列宽在（最小列宽，移动中计算的列宽）取最大值
            const columnWidth = Math.max(
              minLeft - _this.dragState.startColumnLeft,
              columnRect.width + deltaLeft
            );
            column.width = column.realWidth = columnWidth;
            raf = requestAnimationFrame(() => {
              (this as any).doLayout();
              raf = null;
            });
            endMoveFlag = true; // 标记结束时不需要调整列宽
            return;
          } // 到此结束

          // 初始没有滚动时
          // 该情况下由于minwidth压缩/分配剩余空间，导致线和列错位，需要计算该列前面的伸缩量进行动态调整
          if (initNoScroll) {
            // minWidth会按照比例分配剩余空间，所以在拖拽时会先按比例压缩分配剩余的空间
            if (
              this.hasClass(tableBodyWrapper, "is-scrolling-none") &&
              !freeze
            ) {
              // 当没有剩余空间或当前列到了最小宽度时不再需要计算伸缩量
              const sign = deltaLeft > 0 ? 1 : -1; // 记录下符号，1向右，-1向左
              const l = Math.floor((Math.abs(deltaLeft) * ratio) / (1 + ratio)); // 列方程解拖拽列左面的伸缩量
              s = l * sign;
            }
            const proxyLeft = _this.dragState.startLeft + deltaLeft - s; // 加上伸缩量
            if (proxyLeft <= minLeft - s) {
              // 对最小宽度做个保护
              freeze = true;
            } else {
              freeze = false;
            }
            resizeProxy.style.left = Math.max(minLeft - s, proxyLeft) + "px";
            const columnWidth = Math.max(
              minLeft - _this.dragState.startColumnLeft,
              columnRect.width + deltaLeft
            );
            // 列宽在（最小列宽，移动中计算的列宽）取最大值
            column.width = column.realWidth = columnWidth;
            raf = requestAnimationFrame(() => {
              (this as any).doLayout();
              raf = null;
            });
            endMoveFlag = true; // 标记
            return;
          } // 到此结束

          endMoveFlag = false; // 修改回标志

          const proxyLeft = _this.dragState.startLeft + deltaLeft - s;

          const num = Math.max(minLeft, proxyLeft); // 存个值

          resizeProxy.style.left = num + "px";

          // 算出当前列宽度，重新布局
          // 宽度计算不要放进raf中，（快速拖一下）||（内容大于宽度&&宽度由小变大）会出问题，但是会有些卡顿
          const columnWidth = num - _this.dragState.startColumnLeft;
          column.width = column.realWidth = columnWidth;
          raf = requestAnimationFrame(() => {
            (this as any).doLayout();
            raf = null;
          });
        };

        const handleMouseUp = () => {
          if (_this.dragging) {
            const { startColumnLeft, startLeft } = _this.dragState;
            if (!endMoveFlag) {
              // 为true时不需要重设列宽
              const finalLeft = parseInt(resizeProxy.style.left, 10);
              const columnWidth = finalLeft - startColumnLeft;
              column.width = column.realWidth = columnWidth;
            }
            table.$emit(
              "header-dragend",
              column.width,
              startLeft - startColumnLeft,
              column,
              event
            );

            _this.store.scheduleLayout();

            document.body.style.cursor = "";
            _this.dragging = false;
            _this.draggingColumn = null;
            _this.dragState = {};

            table.resizeProxyVisible = false;
          }

          document.removeEventListener("mousemove", handleMouseMove);
          document.removeEventListener("mouseup", handleMouseUp);
          document.onselectstart = null;
          document.ondragstart = null;

          if (this.useCache) {
            this.saveAdjustColumns(); // 保存列宽
          }

          setTimeout(function() {
            removeClass(columnEl, "noclick");
            removeClass(tableEl, "is-my-click"); // 清除自定义的类名
          }, 0);
        };

        document.addEventListener("mousemove", handleMouseMove);
        document.addEventListener("mouseup", handleMouseUp);
      }
    },
    hasClass(el: HTMLElement, cls: string) {
      if (!el || !cls) return false;
      if (cls.indexOf(" ") !== -1)
        throw new Error("className should not contain space.");
      if (el.classList) {
        return el.classList.contains(cls);
      } else {
        return (" " + el.className + " ").indexOf(" " + cls + " ") > -1;
      }
    },
    // 用于获取表格头文本高度
    getTextWidth(str: string) {
      const tempDiv = document.createElement("div");
      tempDiv.style.position = "absolute";
      tempDiv.style.visibility = "hidden";
      tempDiv.style.width = "auto";
      tempDiv.style.whiteSpace = "nowrap";
      tempDiv.innerHTML = str;
      document.body.appendChild(tempDiv);
      const textWidth = tempDiv.offsetWidth;
      document.body.removeChild(tempDiv);
      return textWidth;
    }
  }
});

export default MyTable;
